// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604241150/js/" + chunkId + "." + {"44":"d5f34f38","225":"e12bb6cd","481":"ddf35f38","486":"8a5c6a52","770":"4d007865"}[chunkId] + ".0.6327287587287498.chunk.js";
};